export const MAX_WIDTH_VALUE = 16;
export const MIN_WIDTH_VALUE = 1;
